export const ko = {
  // Meta Tags
  meta: {
    title: '서울 시험소 분석 서비스 ISO 17025 Testing Laboratory',
    description: 'ILAC 인정 국제 공인 시험소. 패션 주얼리, 유아용품 및 일반 상품에 대한 유럽·미국 유해물질 법령 시험 분석 전문. ISO/IEC 17025 인증 보유. 유해물질 시험, 어린이 용품 안전성 시험, 적합성 평가 서비스 제공.',
    keywords: '시험소, 유해물질 시험, 어린이 용품 안전성, ISO 17025, ILAC 인정, 패션 주얼리 분석',
    ogTitle: 'ISO 17025 Testing Laboratory - 국제 공인 시험소',
    ogDescription: 'ILAC 인정 국제 공인 시험소. 유해물질 시험 분석 전문'
  },

  // Navigation
  nav: {
    home: '홈',
    about: '회사소개',
    services: '서비스',
    certifications: '인증자격',
    equipment: '장비소개',
    virtualTour: '가상투어',
    resources: '자료센터',
    contact: '문의하기',
    business: '주요사업',
    testingAnalysis: '시험/분석',
    productTesting: '제품시험평가',
    certificationMark: '인증업무/인증마크',
    customerSupport: '고객・기술지원',
    industrySolutions: '산업별 솔루션',
    certificationSupport: '인증제도 지원(분야별)',
    technicalCenter: '기술센터(부속)',
    jewelry: '주얼리',
    childrenBaby: '어린이 유아용품',
    educationCenter: '교육센터',
    regulationResearch: '법규연구/표준개발',
    equipmentCertifications: '장비/자격',
    announcements: '공지사항',
    location: '찾아오시는 길',
    ceoMessage: 'CEO 인사말',
    managementPolicy: '경영방침',
    companyInfo: '회사소개',
    companyHistory: '회사연혁',
    organization: '조직도'
  },

  // Hero Section
  hero: {
    badge: 'ISO/IEC 17025 인증',
    
    // Slide titles
    slide1Title: '선진 화학 분석',
    slide2Title: '종합 제품 안전 시험',
    slide3Title: '연구개발 지원',
    slide4Title: '환경 인증 및 탄소 발자국',

    // Slide 1
    slide1MainTitle: 'ISO/IEC 17025 인증 제3자 공인 시험기관',
    slide1Point1: '정확한 분석 데이터를 기반으로',
    slide1Point1Text: '정확한 분석 데이터를 기반으로',
    slide1Point2: '신뢰도 높은 시험 성적서와 인증서를 제공합니다.',
    slide1Point2Text: '신뢰도 높은 시험 성적서와 인증서를 제공합니다.',

    // Slide 2
    slide2MainTitle: '최고 수준의 기술 표준과 전문 엔지니어',
    slide2Point1: '안전/위생 환경을 고려한 엄격한 제품 인증 규격',
    slide2Point1Text: '안전/위생 환경을 고려한 엄격한 제품 인증 규격',
    slide2Point2: '오랜 경험을 통해 축적된 전문 평가 서비스',
    slide2Point2Text: '오랜 경험을 통해 축적된 전문 평가 서비스',
    slide2Point3: '고객과 시장이 신뢰하는 시험 인증 전문기관',
    slide2Point3Text: '고객과 시장이 신뢰하는 시험 인증 전문기관',

    // Slide 3
    slide3MainTitle: '연구·개발 & 기술 서비스',
    slide3Point1: '불량 원인 파악을 위한 애로 기술 해결',
    slide3Point1Text: '불량 원인 파악을 위한 애로 기술 해결',
    slide3Point2: '재료 선정부터 완성품까지 전 과정 지원',
    slide3Point2Text: '재료 선정부터 완성품까지 전 과정 지원',
    slide3Point3: '고객과 시장이 신뢰하는 시험·인증 전문기관',
    slide3Point3Text: '고객과 시장이 신뢰하는 시험·인증 전문기관',

    // Slide 4
    slide4MainTitle: '환경 인증 및 지속 가능성',
    slide4Point1: '탄소 발자국 평가',
    slide4Point1Text: '종합적인 탄소 발자국 평가를 제공합니다',
    slide4Point2: '환경 영향 평가',
    slide4Point2Text: '상세한 환경 영향 평가 서비스를 제공합니다',
    slide4Point3: '지속 가능한 개발 목표: ',
    slide4Point3Text: '지속 가능한 개발 목표: 기업의 지속 가능성 목표 달성과 국제 환경 기준 준수를 지원합니다.',

    // Products
    product1: '주얼리/패션 액세서리',
    product2: '장난감/유아용품',
    product3: '유아복',
    product4: '귀걸이',
    product5: '유아 베개',
    product6: '레고 스파이크',
    product7: '여성 블라우스',
    product8: '금 팔찌',
    product9: '자전거 헬멧',
    product10: '기어 휠',
    product11: '문구류',
    product12: '섬유/가죽 제품',
    product13: '가구/실내장식',
    product14: '식기/식품 용기',
    product15: '포장/운송',
    product16: '검사/현장 테스트',

    // Equipment
    equipment1Name: 'GC-MS',
    equipment1Desc: 'Agilent Technologies의 가스 크로마토그래피 질량분석기입니다. 유기화합물 분석 및 미량 성분 검출에 사용됩니다.',
    equipment1App1: '유기화합물 분석',
    equipment1App2: '휘발성 물질 검출',
    equipment1App3: '환경 오염물질 분석',
    equipment2Name: '장비 2',
    equipment2Desc: '두 번째 장비에 대한 설명입니다. 사진을 올려주시면 실제 장비 정보로 업데이트됩니다.',
    equipment2App1: '적용 분야 1',
    equipment2App2: '적용 분야 2',
    equipment2App3: '적용 분야 3',
    equipment3Name: '장비 3',
    equipment3Desc: 'Rayleigh UV-1801 자외선/가시광선 분광광도계입니다. 물질의 흡광도 측정 및 농도 분석에 사용됩니다.',
    equipment3App1: '흡광도 측정',
    equipment3App2: '농도 분석',
    equipment3App3: '물질 정성/정량 분석',
    equipment4Name: '장비 4',
    equipment4Desc: '네 번째 장비에 대한 설명입니다. 사진을 올려주시면 실제 장비 정보로 업데이트됩니다.',
    equipment5Name: '장비 5',
    equipment5Desc: '다섯 번째 장비에 대한 설명입니다. 사진을 올려주시면 실제 장비 정보로 업데이트됩니다.',
    equipment6Name: '장비 6',
    equipment6Desc: '여섯 번째 장비에 대한 설명입니다. 사진을 올려주시면 실제 장비 정보로 업데이트됩니다.',
    equipment7Name: '장비 7',
    equipment7Desc: 'ETHOS EASY 마이크로파 소화 시스템입니다. 시료의 전처리 및 소화 작업에 사용되는 고급 장비입니다.',
    equipment7App1: '시료 전처리',
    equipment7App2: '마이크로파 소화',
    equipment7App3: '금속 분석 전처리',
    equipment8Name: '장비 8',
    equipment8Desc: '고온 머플 퍼니스(Muffle Furnace)입니다. 시료의 회화, 열처리 및 고온 실험에 사용되는 필수 장비입니다.',
    equipment8App1: '시료 회화',
    equipment8App2: '고온 열처리',
    equipment8App3: '재 함량 측정',
    equipment9Name: '장비 9',
    equipment9Desc: '아홉 번째 장비에 대한 설명입니다. 사진을 올려주시면 실제 장비 정보로 업데이트됩니다.',
    equipment10Name: '장비 10',
    equipment10Desc: '열 번째 장비에 대한 설명입니다. 사진을 올려주시면 실제 장비 정보로 업데이트됩니다.',
    equipment11Name: '장비 11',
    equipment11Desc: '열한 번째 장비에 대한 설명입니다. 사진을 올려주시면 실제 장비 정보로 업데이트됩니다.',
    equipment12Name: '장비 12',
    equipment12Desc: '열두 번째 장비에 대한 설명입니다. 사진을 올려주시면 실제 장비 정보로 업데이트됩니다.',
    equipment13Name: '장비 13',
    equipment13Desc: '열세 번째 장비에 대한 설명입니다. 사진을 올려주시면 실제 장비 정보로 업데이트됩니다.',
    equipment14Name: '장비 14',
    equipment14Desc: '열네 번째 장비에 대한 설명입니다. 사진을 올려주시면 실제 장비 정보로 업데이트됩니다.',
    equipment15Name: '장비 15',
    equipment15Desc: 'COX EM-30AX 첨단 분석 시스템입니다. 정밀한 분석과 측정을 위한 고급 장비입니다.',
    equipment15App1: '정밀 분석',
    equipment15App2: '성분 측정',
    equipment15App3: '품질 관리',
    equipment16Name: '장비 16',
    equipment16Desc: '열여섯 번째 장비에 대한 설명입니다. 사진을 올려주시면 실제 장비 정보로 업데이트됩니다.',
    equipment17Name: '장비 17',
    equipment17Desc: '열일곱 번째 장비에 대한 설명입니다. 사진을 올려주시면 실제 장비 정보로 업데이트됩니다.',
    equipment18Name: '장비 18',
    equipment18Desc: 'Vision 검사 시스템입니다. 제품의 외관 검사 및 품질 관리에 사용되는 정밀 검사 장비입니다.',
    equipment18App1: '외관 검사',
    equipment18App2: '품질 관리',
    equipment18App3: '결함 검출',
    equipment19Name: '장비 19',
    equipment19Desc: 'X-ray 형광 분석기(XRF)입니다. 비파괴 방식으로 물질의 원소 조성을 분석하는 정밀 장비입니다.',
    equipment19App1: '원소 분석',
    equipment19App2: '비파괴 검사',
    equipment19App3: '금속 성분 분석',
    equipment20Name: '장비 20',
    equipment20Desc: '열스무 번째 장비에 대한 설명입니다. 사진을 올려주시면 실제 장비 정보로 업데이트됩니다.',
    equipment21Name: '장비 21',
    equipment21Desc: '열한스무 번째 장비에 대한 설명입니다. 사진을 올려주시면 실제 장비 정보로 업데이트됩니다.',

    // Cards
    card1Title: 'ISO 17025 인증',
    card1Desc: '국제 공인 시험소 품질 관리 시스템',
    card2Title: '글로벌 네트워크',
    card2Desc: 'ILAC MRA 상호인정협정 가입',
    card3Title: '첨단 장비',
    card3Desc: '최신 분석 장비와 전문 인력',
    card4Title: '전문 팀',
    card4Desc: '풍부한 경험의 전문가 그룹',

    // Buttons
    btnServices: '서비스 보기',
    btnContact: '문의하기'
  },

  // About Section
  about: {
    badge: '회사소개',
    title: 'CTL 소개',
    subtitle: '신뢰와 전문성으로 고객의 성공을 지원하는 국제 공인 시험소',
    mission: '우리의 미션',
    missionDesc: '최고 수준의 시험 분석 서비스를 통해 고객의 제품이 전 세계 시장에서 안전하게 유통될 수 있도록 지원하며, 소비자의 건강과 안전을 보호하는 데 기여합니다.',
    vision: '우리의 비전',
    visionDesc: '아시아 최고의 시험 분석 기관으로 성장하여 글로벌 품질 표준을 선도하고, 지속적인 혁신과 발전을 통해 업계의 벤치마크가 되는 것입니다.',
    values: '핵심 가치',
    value1: '정확성',
    value1Desc: '정밀한 분석과 신뢰할 수 있는 결과로 고객의 신뢰를 얻습니다',
    value2: '전문성',
    value2Desc: '풍부한 경험과 전문 지식을 바탕으로 최상의 서비스를 제공합니다',
    value3: '신속성',
    value3Desc: '빠른 시험 처리와 보고서 발행으로 고객의 시간을 절약합니다',
    value4: '고객 중심',
    value4Desc: '고객 만족을 최우선으로 생각하며 지속적인 지원을 제공합니다'
  },

  // History Section
  history: {
    badge: '회사 연혁',
    title: '우리의 성장 과정',
    subtitle: 'CTL의 발전 과정과 주요 성과를 소개합니다',
    year2026: '2026년 ~',
    event2026_1: 'CTL 한국지사 및 베트남 시험소 설립 추진 중',
    year2018: '2018년 ~',
    event2018_1: 'ISO/IEC 17025 공인 시험기관 제4차 시험 항목 확대 지정',
    event2018_2: '유해물질 분석 및 전 분야 생활소비제품 시험 서비스 확대',
    year2017: '2017년 ~',
    event2017_1: 'ISO/IEC 17025 공인 시험기관 지정【ILAC / CNAS】',
    event2017_2: '1,200여 개 수출 기업 및 30여 개 글로벌 바이어 대상 공인 시험 서비스 제공',
    year2016: '2016년 ~',
    event2016_1: '한국 쥬얼리 공동연구원과 표면처리 등 공동 연구개발 협약 체결',
    year2014: '2014년 ~',
    event2014_1: '중·한 공예품 협회와 업무협약(MOU) 체결',
    year2012: '2012년 ~',
    event2012_1: '제3자 독립 법인 시험소 설립(중국 칭다오 및 홍콩)',
    year2008: '2008년 ~',
    event2008_1: '기업 내 제2자 시험소 구축 사업 지원',
    event2008_2: '기업 자체 시험소 운영 지도를 위한 중앙 시험소(Central Testing Lab) 운영',
    year2007: '2007년 ~',
    event2007_1: '미국 CPSIA 및 EU REACH 규정 대응을 위한 HSPM 유해물질 관리 시스템 구축',
    event2007_2: '수출 기업 및 글로벌 바이어 대상 규제 대응 기술 지원 제공'
  },

  // Services Section（ZH 내용과 동기화）
  services: {
    badge: '서비스',
    title: '종합 시험 솔루션',
    subtitle: '화학 분석, 물리적 특성, 제품 안전을 아우르는 전문 시험 서비스',

    service1Title: '화학 시험',
    service1Item1: '유해 물질 분석',
    service1Item2: '금속/비금속/재료 분석',
    service1Item3: '고분자/섬유 분석',
    service1Item4: '완구 등 소비재 위생 시험',
    service1Item5: '귀금속・보석 제품 시험 분석',

    service2Title: '물리 시험',
    service2Item1: '소비재 안전 평가 시험',
    service2Item2: '신뢰성 시험',
    service2Item3: '표면 처리 내구성 평가 시험',
    service2Item4: '섬유 재료 및 전기 재료 난연성 시험',
    service2Item5: '환경 피로 시험',

    service3Title: '제품 안전',
    service3Item1: '귀금속・보석 제품 안전 품질 평가',
    service3Item2: '완구 등 소비재 안전성 평가',
    service3Item3: '가전 제품 안전성 평가',
    service3Item4: '국내외 인증 관련 제품 평가',
    service3Item5: '완전 포장(내외) 제품 평가',

    service4Title: '시스템 인증 및 인증 마크',
    service4Item1: '귀금속 품질 인증',
    service4Item2: 'HSPM・유해 물질 관리',
    service4Item3: 'IATF16949 인증 컨설팅',
    service4Item4: 'SAH 안전 위생 인증',
    service4Item5: '작업장 환경 평가',

    service5Title: '연구 개발',
    service5Item1: '표준물 개발',
    service5Item2: '표준・규격 제정',
    service5Item3: '기술 서적 발행',

    service6Title: '기업 지원',
    service6Item1: '교육・연수',
    service6Item2: '기업 실험실 지원・중앙 실험실 운영',
    service6Item3: '인증 취득 컨설팅'
  },

  // Certifications Section
  certifications: {
    badge: '인증자격',
    title: '국제 인증',
    subtitle: '주요 국제 기관의 공인을 받은 시험소',
    cert1Title: 'ISO/IEC 17025 인증',
    cert1Desc: '시험 및 교정 결과의 정확성과 신뢰성을 보장하는 국제적으로 인정받은 실험실 품질 관리 시스템입니다.',
    cert1Tag1: '국제 표준',
    cert1Tag2: '품질 보증',
    cert1Tag3: '신뢰성',
    cert2Title: 'ILAC MRA 인정',
    cert2Desc: '국제실험실인정협력체 상호인정협정으로, 시험 결과의 전 세계적 수용을 보장합니다.',
    cert2Tag1: '글로벌 인정',
    cert2Tag2: '상호 인정',
    cert2Tag3: '국제 협력',
    cert3Title: '미국 CPSC 인정',
    cert3Desc: '미국 CPSC 실험실 인정을 통과',
    cert3Tag1: 'CPSC 인정',
    cert3Tag2: 'CPC 제작',
    cert3Tag3: '국제 협력',
    region1: '유럽 표준',
    region2: '미국 표준',
    region3: '아시아 표준',
    region4: '국제 표준'
  },

  // Contact Section
  contact: {
    badge: '문의하기',
    title: '연락처',
    subtitle: '시험 프로젝트를 시작할 준비가 되셨나요? 전문가 팀에 문의하세요.',
    
    infoTitle: '연락처 정보',
    phone: '전화',
    email: '이메일',
    address: '주소',
    addressLine1: '',
    addressLine2: '청도시 성양구 서운동로 57호 1동 301호',
    hours: '운영 시간',
    hoursWeekday: '월-금: 08:00-18:00',
    hoursWeekend: '토요일: 08:00-14:00',
    
    quickTitle: '빠른 상담',
    quickDesc: '긴급한 문의사항이 있으신가요? 전화로 바로 상담받으세요.',
    quickPhone: '상담 전화',
    
    formTitle: '문의 양식',
    formName: '이름',
    formCompany: '회사명',
    formEmail: '이메일',
    formPhone: '전화번호',
    formService: '서비스 종류',
    formServicePlaceholder: '서비스를 선택하세요',
    formServiceOption1: '화학 분석',
    formServiceOption2: '물리적 시험',
    formServiceOption3: '제품 안전',
    formServiceOption4: '환경 시험',
    formServiceOption5: '섬유 시험',
    formServiceOption6: '식품 안전',
    formServiceOption7: '기타',
    formMessage: '문의 내용',
    formMessagePlaceholder: '문의하실 내용을 입력해주세요 (최대 500자)',
    formSubmit: '문의하기',
    formSuccess: '문의가 성공적으로 전송되었습니다!',
    formError: '문의 전송 중 오류가 발생했습니다. 다시 시도해주세요.'
  },

  // Equipment Section
  equipment: {
    badge: '장비',
    title: '검사 장비',
    subtitle: '최신 분석 장비와 전문 인원을 배치하여 정확하고 신뢰할 수 있는 검사 결과 제공',
    applicationsLabel: '주요 응용 분야:'
  },

  // Announcements Page
  announcements: {
    badge: '공지사항',
    title: '공지사항',
    subtitle: '현재 공지사항이 없습니다',
    backToHome: '홈으로',
    emptyTitle: '공지사항 없음',
    emptyDesc: '현재 공지사항이 없습니다. 나중에 다시 확인해 주세요.'
  },

  // Location Section
  location: {
    badge: '찾아오시는 길',
    title: '오시는 길',
    subtitle: '편리한 교통으로 쉽게 방문하실 수 있습니다',
    subway: '지하철',
    subwayLine: '청도 지하철 1호선',
    subwayDesc: '하이테크존역 하차 후 도보 5분',
    subwayMapLink: '청도 지하철 노선도를 클릭하여 보기',
    car: '자가용',
    carParking: '무료 주차 가능',
    carDesc: '',
    bus: '버스',
    busLines: '111, 131, 946, 4201번',
    busDesc: '타이핑좡 정류장 하차, 서쪽으로 900m'
  },

  // Footer
  footer: {
    description: 'ISO/IEC 17025 인증을 받은 국제 공인 시험소로서 최고 수준의 시험 분석 서비스를 제공합니다.',
    servicesTitle: '서비스',
    service1: '화학 분석',
    service2: '물리적 시험',
    service3: '제품 안전',
    service4: '환경 시험',
    quickLinksTitle: '바로가기',
    contactTitle: '연락처',
    copyright: '© 2024 청도 시험소. All rights reserved.',
    poweredBy: 'Website Builder'
  },

  // Company submenu
  company: {
    info: '회사소개',
    ceoMessage: 'CEO 인사말',
    history: '회사연혁'
  },

  // Company Info Page
  companyInfo: {
    badge: 'Company Info',
    title: '회사 소개',
    subtitle: '신뢰와 전문성으로 고객의 성공을 지원하는 국제 공인 시험소',
    
    mainTitle: 'CTL(청도 CTL검사기술서비스 유한회사)',
    paragraph1: 'CTL은 2012년 정식 설립, 2017년 CNAS 및 ILAC 국제 공인 인증을 획득한 전문 시험 검사 기관입니다.',
    paragraph2: 'CTL은 모방 장신구, 장난감, 전자 전기제품, 섬유, 가죽 등 다양한 소비재 분야의 시험 검사 서비스를 제공하고 있으며, 유럽, 미국, 일본, 한국, 중국 등 전 세계를 아우르는 글로벌 서비스 네트워크를 구축하고 있습니다. 또한 중국 내 주요 전자 상거래 플랫폼과의 전략적 협력을 통해 산업 전반의 품질 경쟁력 향상에 기여하고 있습니다.',
    paragraph3: '국제 수준의 첨단 시험 장비와 숙련된 전문 기술 인력을 기반으로 CTL은 과학적 공정성, 정확성, 효율성이라는 서비스 이념 아래 국내외 시험 규격과 법규를 엄격히 준수합니다.',
    paragraph4: '고객에게 신뢰도 높은 시험 검사 성적서를 제공함은 물론, 각국의 안전 환경 규제 요구 사항에 대한 시험 분석 및 기술 지원을 통해 글로벌 시장 진출과 원활한 제품 유통을 지원하고 있습니다.',
    paragraph5: 'CTL은 기업의 소재 개발과 품질 관리 전반에 걸쳐 함께 성장하는 핵심 파트너를 지향합니다.',
    
    tag1: 'CNAS 인증',
    tag2: 'ILAC MRA 가입',
    tag3: '국제 공인',
    
    missionTitle: '우리의 미션',
    missionDesc: '최고 수준의 시험 분석 서비스를 통해 고객의 제품이 전 세계 시장에서 안전하게 유통될 수 있도록 지원하며, 소비자의 건강과 안전을 보호하는 데 기여합니다.',
    
    visionTitle: '우리의 비전',
    visionDesc: '아시아 최고의 시험 분석 기관으로 성장하여 글로벌 품질 표준을 선도하고, 지속적인 혁신과 발전을 통해 업계의 벤치마크가 되는 것입니다.',
    
    valuesTitle: '핵심 가치',
    value1Title: '정확성',
    value1Desc: '정밀한 분석과 신뢰할 수 있는 결과로 고객의 신뢰를 얻습니다',
    value2Title: '전문성',
    value2Desc: '풍부한 경험과 전문 지식을 바탕으로 최상의 서비스를 제공합니다',
    value3Title: '신속성',
    value3Desc: '빠른 시험 처리와 보고서 발행으로 고객의 시간을 절약합니다',
    value4Title: '고객 중심',
    value4Desc: '고객 만족을 최우선으로 생각하며 지속적인 지원을 제공합니다',
    companyName: '청도 검사 기술 서비스 유한회사',
    
    stat1: '2015',
    stat1Label: '설립 연도',
    stat2: '50+',
    stat2Label: '전문 인력',
    stat3: '10,000+',
    stat3Label: '연간 시험 건수',
    stat4: '30+',
    stat4Label: '협력 국가',
    
    ctaTitle: '더 자세한 정보가 필요하신가요?',
    ctaDesc: '전문 상담원이 귀사의 요구사항을 신속하게 검토하고 최적의 솔루션을 제안해드립니다',
    contactButton: '문의하기',
    servicesButton: '서비스 보기'
  },

  // CEO Message Page
  ceoMessage: {
    badge: 'CEO 인사말',
    title: 'CTL 인사말',
    subtitle: '글로벌 신뢰를 만드는 시험·분석의 기준',
    greeting: 'CTL은 ISO/IEC 17025 국제 표준에 따라 운영되며, CNAS 인정 및 ILAC MRA 상호인정을 보유한 공인 시험·분석 기관입니다.',
    paragraph1: '국제 수준의 시험·분석 장비와 풍부한 경험을 갖춘 전문 인력을 바탕으로, 정확하고 신뢰성 있는 시험·검사 서비스를 제공하고 있으며, CTL의 시험 결과와 성적서는 세계 주요 국가와 시장에서 폭넓게 인정받고 있습니다.',
    paragraph2: '우리는 신속한 시험 처리와 체계적인 보고서 발행을 통해 고객의 소중한 시간을 절약하고, 합리적인 비용으로 최고 수준의 품질을 제공하는 것을 기본 원칙으로 삼고 있습니다. 또한 지속적인 기술 지원과 전문적인 컨설팅을 통해 고객의 지속적인 성장을 함께 만들어가고자 합니다.',
    promiseTitle: '핵심 가치',
    promise1: '과학적 공정성',
    promise2: '정확성',
    promise3: '효율성',
    promise4: '각국의 안전 및 환경 규제 대응 적극 지원',
    paragraph3: 'CTL은 단순히 시험 결과만을 제공하는 기관에 머무르지 않습니다. 고객의 제품이 글로벌 시장에서 안전하고 원활하게 유통될 수 있도록 지원하는 신뢰받는 파트너가 되는 것을 목표로 하고 있습니다. 우리는 고객의 성공이 곧 우리의 성공이라는 신념 아래, 모든 업무에 최선을 다하고 있습니다.',
    paragraph4: '국가별 상품 관련 규정에 대한 지속적인 연구와 전문성을 기반으로, \'과학적 공정성, 정확성, 효율성\'을 핵심 가치로 삼아 각국의 안전 및 환경 규제 대응을 적극적으로 지원하고 있습니다. 특히 주얼리, 아동용품 및 각종 소비재 분야에 있어, 제품 개발 단계부터 세계 시장에서의 안전한 유통에 이르기까지 고객의 장기적인 글로벌 파트너로서 지속적인 지원을 제공하겠습니다.',
    paragraph5: '앞으로도 CTL은 지속적인 기술 개발과 품질 혁신을 통해 아시아를 넘어 세계를 대표하는 시험·분석 기관으로 성장해 나가겠습니다. 고객 여러분의 변함없는 관심과 성원을 부탁드립니다.',
    closing: '감사합니다.',
    ceoName: '김재명',
    ceoTitle: '대표이사',
    companyName: 'CTL (청도 CTL 시험·검사 기술 서비스 유한회사)',
    philosophyTitle: '경영 철학',
    value1Title: '과학적 공정성',
    value1Desc: '정확하고 공정한 시험 결과로 고객의 신뢰를 얻습니다',
    value2Title: '정확성',
    value2Desc: '최고의 전문 인력과 장비로 신뢰할 수 있는 시험·분석을 제공합니다',
    value3Title: '효율성',
    value3Desc: '신속하고 체계적인 서비스로 고객 성공을 위한 파트너가 됩니다',
    ctaTitle: '시험·분석 서비스가 필요하신가요?',
    ctaDescription: '전문 상담원이 귀사의 요구사항을 신속하게 검토하고 최적의 솔루션을 제안해드립니다',
    contactButton: '문의하기',
    servicesButton: '서비스 보기',
    backToHome: '홈으로'
  },

  // Business Page
  business: {
    badge: '주요 사업',
    title: '주요 사업',
    subtitle: 'CTL의 다양한 사업 영역을 소개합니다.',
    backToHome: '홈으로',
    laboratoryName: 'ISO 17025 시험실',
    laboratoryDesc: 'ILAC 인정 시험 서비스',
    col1Header: '시험분석',
    col2Header: '제품 적합성 평가',
    col3Header: '제품 검사',
    col4Header: 'System 인증 및 인증마크',
    col5Header: '연구개발',
    col6Header: '기업지원',
    ctaTitle: '주요 사업 문의',
    ctaDesc: '전문 상담원이 귀사의 요구사항을 신속하게 검토하고 최적의 솔루션을 제안해드립니다.',
    ctaPhone: '고객 상담 전화',
    tableData: [
      { rowHeader: '소재/원자재 분석', col1: ['패션·주얼리 제품'], col2: ['제품 품질 검사'], col3: ['SA-8000'], col4: ['표준물 개발'], col5: ['교육·연수'] },
      { rowHeader: '유해물질 분석', col1: ['완구, 유아용품, 문구'], col2: ['공장 심사'], col3: ['HSPM'], col4: ['표준·규격 제정'], col5: ['컨설팅 지원'] },
      { rowHeader: '고분자 재료', col1: ['위생용품'], col2: ['현장 시험 검사'], col3: ['ISO9000/140000'], col4: ['기술 도서 발행'], col5: [] },
      { rowHeader: '귀금속 재료 분석', col1: ['섬유제품'], col2: [], col3: ['IATF-16949 인증 컨설팅'], col4: [], col5: [] },
      { rowHeader: '금속/비금속/광물', col1: ['노인 안전 제품'], col2: [], col3: ['SAH 안전 위생 인증'], col4: [], col5: [] },
      { rowHeader: '표면처리/도금액 분석', col1: ['환경/안전/보건 제품'], col2: [], col3: ['귀금속 품질 인증'], col4: [], col5: [] },
      { rowHeader: '섬유 재료 및 물성 시험', col1: ['자동차 전자 전기 부품 시험'], col2: [], col3: ['작업장 환경 평가'], col4: [], col5: [] },
      { rowHeader: '물리 강도 및 피로 시험', col1: ['가전제품'], col2: [], col3: [], col4: [], col5: [] },
      { rowHeader: '신뢰성 시험', col1: ['완전 포장(내외) 제품 평가'], col2: [], col3: [], col4: [], col5: [] },
      { rowHeader: '생활소비재 관련 시험', col1: ['국내외 인증 관련 제품 평가'], col2: [], col3: [], col4: [], col5: [] },
      { rowHeader: '환경위생 관련 시험 분석', col1: ['제품 불량 원인 분석 평가'], col2: [], col3: [], col4: [], col5: [] },
      { rowHeader: '포장재료 시험', col1: [], col2: [], col3: [], col4: [], col5: [] },
      { rowHeader: '전자 부품 시험', col1: [], col2: [], col3: [], col4: [], col5: [] },
      { rowHeader: '미생물 시험', col1: [], col2: [], col3: [], col4: [], col5: [] }
    ]
  },

  // Testing Analysis Page
  testingAnalysis: {
    badge: '주요 사업',
    title: '시험/분석 항목',
    subtitle: 'ISO 17025 인증을 받은 시험실에서 정확하고 신뢰할 수 있는 시험 분석 서비스를 제공합니다.',
    backToHome: '홈으로',
    laboratoryName: 'ISO 17025 시험실',
    laboratoryDesc: 'ILAC 인정 시험 서비스',
    
    category1Title: '소재/재료 분석',
    category1Items: ['금속/비금속', '광물질', '고분자물질', '유리/세라믹 물질', '귀금속 분석'],
    
    category2Title: '유해물질 분석',
    category2Items: [
      '중금속', '프탈레이트', 'pH', '포름알데히드', '다환방향족탄화수소', 
      '아조 염료', 'APEOs', '디메틸푸마레이트 (DMFu 또는 DMF)', '비스페놀 A',
      '발암성 염료', '6가 크롬', '펜타클로로페놀', '테트라클로로페놀', '분산 염료', 
      '난연제', '니켈 용출', '니트로소아민', 
      '유기주석', '과불소화합물', '용매'
    ],
    
    category3Title: '표면 처리/도금액 시험',
    category3Items: ['금/은', '귀금속 함량', '도금액 분석'],
    
    category4Title: '물리 시험',
    category4Items: ['인장강도', '경도(HV)', '내구성 시험'],
    
    category5Title: '섬유 시험',
    category5Items: ['방화도 시험', '세탁 시험 등 30종', '재료 식별'],
    
    category6Title: '신뢰성 시험',
    category6Items: ['염수 분무 시험', '환경 노화 시험', '내마모성 시험', '광조사 시험'],
    
    category7Title: '포장 시험',
    category7Items: ['운송시험', '낙하 시험', '파열/엣지 크러시 시험'],
    
    ctaTitle: '시험 분석 문의',
    ctaDesc: '전문 상담원이 귀사의 시험 분석 요구사항을 상세히 안내해드립니다.',
    ctaPhone: '고객 상담 전화'
  },

  // Certifications Page
  certificationsPage: {
    badge: 'Certifications',
    title: '인증 현황',
    subtitle: '국제적으로 인정받은 시험소 인증 및 자격 현황',
    backToHome: '홈으로',
    
    iso17025Title: 'ISO/IEC 17025',
    iso17025Desc: '시험 및 교정 시험소의 적격성에 대한 국제 표준 인증을 획득하여, 시험 결과의 정확성과 신뢰성을 국제적으로 보증받고 있습니다.',
    iso17025Tag1: '국제 표준',
    iso17025Tag2: '품질 보증',
    iso17025Tag3: '기술 적격성',
    
    ilacTitle: 'ILAC MRA',
    ilacDesc: '국제시험소인정협력기구(ILAC) 상호인정협정에 가입하여, 발행하는 시험 성적서가 전 세계적으로 인정받고 있습니다.',
    ilacTag1: '글로벌 인정',
    ilacTag2: '상호 인정',
    ilacTag3: '국제 협력',
    
    regionalTitle: '지역별 인증 현황',
    region1: 'European Regulations',
    region1Standards: ['REACH/UK REACH', 'ROHS/LVD Directives', 'GDPR/GPSR', 'Toy Safety Directives'],
    region2: 'USA Regulations',
    region2Standards: ['16 CFR CPSC/CPSIA', 'California & other State Law', '21CFR/29CFR', 'CPC/GPSC'],
    region3: 'Asia Regulations',
    region3Standards: ['GB & CCC', 'KS & KC/K-REACH', 'JIS & PSE/PSC', 'ASEAN Harmonized Standard'],
    region4: 'International Harmonized Regulations',
    region4Standards: ['IECEE CB Scheme', 'ISO/IEC', 'GHS', 'Codex Alimentarius'],
    
    certDetailsTitle: '인증 세부 사항',
    chemicalCertTitle: '화학 시험 인증',
    chemicalCertItems: ['ICP-MS 분석', 'GC-MS 분석', 'LC-MS/MS 분석', 'XRF 분석'],
    
    physicalCertTitle: '물리 시험 인증',
    physicalCertItems: ['기계적 특성', '열 분석', '전기적 시험', '치수 측정'],
    
    safetyCertTitle: '제품 안전 인증',
    safetyCertItems: ['장난감 안전', '섬유 안전', '전자제품 안전', '식품 접촉 재료'],
    
    envCertTitle: '환경 시험 인증',
    envCertItems: ['RoHS', 'REACH', 'Phthalates', 'VOC'],
    
    microCertTitle: '미생물 시험 인증',
    microCertItems: ['세균 검사', '곰팡이 검사', '효모 검사', '병원균 검사'],
    
    preciousCertTitle: '귀금속 시험 인증',
    preciousCertItems: ['금 순도', '은 순도', '백금 순도', '다이아몬드 감정'],
    
    // 실제 인증서 정보
    actualCertsTitle: '보유 인증서',
    cnasTitle: 'CNAS 인증서',
    cnasNumber: '인증번호: CNAS L10485',
    
    cpscCertTitle: 'CPSC 인정',
    cpscCertNumber: '회원번호: 1698'
  },

  // Industry Solutions Page
  industrySolutions: {
    badge: '고객지원',
    title: '산업별 솔루션',
    subtitle: '각 산업 분야의 특성에 맞춘 전문적인 시험, 분석, 인증 솔루션을 제공합니다',
    servicesProvided: '제공 서비스',
    ctaTitle: '맞춤형 솔루션이 필요하신가요?',
    ctaDesc: '귀사의 산업 분야와 제품 특성에 맞는 최적의 솔루션을 제안해 드립니다',
    ctaButton: '상담 문의하기',
    jewelry: {
      title: '주얼리 산업',
      description: '귀금속 및 보석류 제품의 품질 보증과 안전성 확보를 위한 종합 솔루션',
      service1: '귀금속 순도 분석 (금, 은, 백금 등)',
      service2: '보석 감정 및 품질 평가',
      service3: '유해물질 검사 (니켈, 카드뮴, 납 등)',
      service4: '물리적 안전성 시험',
      service5: '국제 인증 지원 (REACH, RoHS)'
    },
    children: {
      title: '어린이/유아용품 산업',
      description: '어린이와 유아의 안전을 최우선으로 하는 전문 시험 및 인증 솔루션',
      service1: '물리적 안전성 시험 (날카로운 모서리, 작은 부품)',
      service2: '화학적 안전성 시험 (프탈레이트, 중금속)',
      service3: '가연성 시험',
      service4: 'EN 71, ASTM F963, CPSIA 인증 지원',
      service5: '제품 개선 컨설팅'
    },
    textile: {
      title: '섬유/의류 산업',
      description: '섬유 제품의 품질과 안전성을 보장하는 전문 시험 서비스',
      service1: '섬유 성분 분석',
      service2: '염색 견뢰도 시험',
      service3: '유해물질 검사 (아조염료, 포름알데히드)',
      service4: '물리적 성능 시험 (강도, 내구성)',
      service5: 'Oeko-Tex Standard 100 인증 지원'
    },
    cosmetics: {
      title: '화장품 산업',
      description: '화장품의 안전성과 효능을 검증하는 전문 분석 서비스',
      service1: '미생물 시험 (총균수, 대장균, 녹농균)',
      service2: '중금속 분석 (납, 비소, 수은)',
      service3: '방부제 및 보존제 분석',
      service4: '피부 자극 시험',
      service5: 'ISO 22716 (GMP) 인증 지원'
    },
    food: {
      title: '식품 산업',
      description: '식품의 안전성과 품질을 보장하는 종합 분석 서비스',
      service1: '영양성분 분석',
      service2: '미생물 검사',
      service3: '잔류농약 검사',
      service4: '중금속 분석',
      service5: 'HACCP, ISO 22000 인증 지원'
    },
    electronics: {
      title: '전자/전기 산업',
      description: '전자제품의 안전성과 성능을 검증하는 전문 시험 서비스',
      service1: '전기 안전성 시험',
      service2: '유해물질 검사 (RoHS, REACH)',
      service3: 'EMC 시험 (전자파 적합성)',
      service4: '배터리 안전성 시험',
      service5: 'CE, FCC 인증 지원'
    },
    packaging: {
      title: '포장재 산업',
      description: '포장재의 안전성과 환경 친화성을 검증하는 전문 서비스',
      service1: '식품 접촉 재료 시험',
      service2: '중금속 용출 시험',
      service3: '물리적 성능 시험',
      service4: '생분해성 시험',
      service5: 'FDA, EU 규정 적합성 평가'
    },
    medical: {
      title: '의료기기 산업',
      description: '의료기기의 안전성과 효능을 검증하는 전문 시험 서비스',
      service1: '생체적합성 시험',
      service2: '멸균 검증',
      service3: '물리적/기계적 성능 시험',
      service4: '전기 안전성 시험',
      service5: 'ISO 13485, CE 인증 지원'
    }
  },

  // Jewelry Technical Center Page
  jewelryCenter: {
    badge: '기술센터(부설)',
    title: '주얼리 기술센터',
    subtitle: '귀금속 및 보석류 제품의 품질 보증과 안전성 확보를 위한 전문 기술 지원 센터',
    servicesTitle: '전문 시험 서비스',
    servicesSubtitle: '주얼리 산업에 특화된 종합 시험 및 분석 서비스',
    equipmentTitle: '전문 장비',
    equipmentSubtitle: '최첨단 분석 장비로 정확한 시험 결과 제공',
    ctaTitle: '주얼리 시험이 필요하신가요?',
    ctaDesc: '전문 기술진이 귀사의 제품에 최적화된 시험 솔루션을 제공합니다',
    ctaButton: '상담 문의하기',
    service1: {
      title: '귀금속 순도 분석',
      description: '금, 은, 백금 등 귀금속의 정확한 순도 측정',
      item1: '금 순도 분석 (K 단위)',
      item2: '은 순도 분석',
      item3: '백금 순도 분석',
      item4: '합금 성분 분석'
    },
    service2: {
      title: '보석 감정',
      description: '다이아몬드 및 각종 보석의 품질 평가',
      item1: '다이아몬드 4C 평가',
      item2: '컬러 스톤 감정',
      item3: '진주 품질 평가',
      item4: '합성석 감별'
    },
    service3: {
      title: '유해물질 검사',
      description: '인체에 유해한 물질의 함유량 측정',
      item1: '니켈 용출 시험',
      item2: '카드뮴 검사',
      item3: '납 함량 분석',
      item4: '크롬 검사'
    },
    service4: {
      title: '물리적 안전성 시험',
      description: '제품의 내구성 및 안전성 평가',
      item1: '날카로운 모서리 검사',
      item2: '작은 부품 시험',
      item3: '인장 강도 시험',
      item4: '내마모성 시험'
    },
    service5: {
      title: '국제 인증 지원',
      description: '해외 수출을 위한 인증 획득 지원',
      item1: 'REACH 인증',
      item2: 'RoHS 인증',
      item3: 'California Prop 65',
      item4: 'KC 인증'
    },
    service6: {
      title: '품질 보증서 발급',
      description: '공신력 있는 품질 보증서 제공',
      item1: '순도 보증서',
      item2: '감정서',
      item3: '시험 성적서',
      item4: '적합성 인증서'
    },
    equipment: {
      icpms: '미량 원소 분석',
      xrf: '비파괴 성분 분석',
      uvvis: '보석 분광 분석',
      scale: '전자저울',
      scaleDesc: '정밀 무게 측정',
      hardness: '경도계',
      hardnessDesc: '보석 경도 측정',
      microscope: '현미경',
      microscopeDesc: '미세 구조 관찰',
      refractometer: '굴절계',
      refractometerDesc: '보석 굴절률 측정',
      spectrometer: '분광기',
      spectrometerDesc: '색상 분석'
    }
  },

  // Children Baby Technical Center Page
  childrenCenter: {
    badge: '기술센터(부설)',
    title: '어린이 유아용품 기술센터',
    subtitle: '어린이와 유아의 안전을 최우선으로 하는 전문 시험 및 기술 지원 센터',
    servicesTitle: '전문 시험 서비스',
    servicesSubtitle: '어린이/유아용품 안전성 평가를 위한 종합 시험 서비스',
    productsTitle: '시험 대상 제품',
    productsSubtitle: '다양한 어린이/유아용품에 대한 전문 시험 서비스',
    standardsTitle: '적용 규격',
    standardsSubtitle: '국내외 주요 안전 규격 준수',
    ctaTitle: '어린이/유아용품 시험이 필요하신가요?',
    ctaDesc: '아이들의 안전을 위한 전문적인 시험 서비스를 제공합니다',
    ctaButton: '상담 문의하기',
    service1: {
      title: '물리적 안전성 시험',
      description: '제품의 물리적 위험 요소 평가',
      item1: '날카로운 모서리 검사',
      item2: '작은 부품 시험',
      item3: '인장 강도 시험',
      item4: '압축 시험'
    },
    service2: {
      title: '화학적 안전성 시험',
      description: '유해 화학물질 함유량 측정',
      item1: '프탈레이트 검사',
      item2: '중금속 분석',
      item3: 'BPA 검사',
      item4: '포름알데히드 측정'
    },
    service3: {
      title: '가연성 시험',
      description: '제품의 화재 안전성 평가',
      item1: '섬유 가연성 시험',
      item2: '플라스틱 가연성 시험',
      item3: '완구 가연성 시험',
      item4: '난연성 평가'
    },
    service4: {
      title: '미생물 시험',
      description: '위생 및 미생물 안전성 평가',
      item1: '총균수 측정',
      item2: '대장균 검사',
      item3: '곰팡이 검사',
      item4: '살모넬라 검사'
    },
    service5: {
      title: '국제 인증 지원',
      description: '국내외 안전 인증 획득 지원',
      item1: 'KC 인증',
      item2: 'EN 71',
      item3: 'ASTM F963',
      item4: 'CPSIA'
    },
    service6: {
      title: '제품 개선 컨설팅',
      description: '안전성 향상을 위한 전문 컨설팅',
      item1: '설계 개선 제안',
      item2: '재료 선택 자문',
      item3: '규격 적합성 검토',
      item4: '사후 관리 지원'
    },
    product1: '완구',
    product2: '유아복',
    product3: '유모차',
    product4: '카시트',
    product5: '젖병/젖꼭지',
    product6: '기저귀',
    product7: '침구류',
    product8: '학용품',
    product9: '놀이기구',
    product10: '안전용품',
    product11: '식기류',
    product12: '목욕용품',
    region: {
      korea: '한국',
      europe: '유럽',
      usa: '미국',
      china: '중국',
      international: '국제',
      japan: '일본',
      taiwan: '대만'
    },
    standard1: '어린이제품 안전 특별법',
    standard2: '완구 안전 규격',
    standard3: '완구 안전 규격',
    standard4: '소비자제품 안전 개선법',
    standard5: '완구 안전 기술 규범',
    standard6: '완구 안전 국제 표준',
    standard7: '일본 산업 규격',
    standard8: '중화민국 국가 표준'
  },

  // Education Center Page
  educationCenter: {
    badge: '고객지원',
    title: '교육센터',
    subtitle: '제품 안전 및 품질 관리 전문가 양성을 위한 체계적인 교육 프로그램',
    programsTitle: '교육 프로그램',
    programsSubtitle: '실무 중심의 전문 교육 과정',
    benefitsTitle: '교육 혜택',
    benefitsSubtitle: '전문성 향상과 경력 개발을 위한 다양한 혜택',
    mainContent: '주요 내용',
    ctaTitle: '교육 신청 문의',
    ctaDesc: '귀사의 교육 요구사항에 맞는 맞춤형 교육 프로그램을 제공합니다',
    ctaButton: '교육 신청 문의',
    level: {
      beginner: '초급',
      intermediate: '중급',
      advanced: '고급'
    },
    program1: {
      title: '품질관리 기초 과정',
      duration: '2일 (16시간)',
      description: '품질관리의 기본 개념과 실무 적용 방법',
      topic1: '품질관리 개론',
      topic2: '통계적 품질관리',
      topic3: '검사 및 시험 방법',
      topic4: '불량 분석 기법'
    },
    program2: {
      title: '제품 안전 규격 과정',
      duration: '3일 (24시간)',
      description: '국내외 제품 안전 규격의 이해와 적용',
      topic1: 'KC 인증 제도',
      topic2: 'EN 71 규격',
      topic3: 'ASTM 규격',
      topic4: 'CPSIA 규정'
    },
    program3: {
      title: '화학 시험 분석 과정',
      duration: '5일 (40시간)',
      description: '화학 시험 방법 및 분석 기술 습득',
      topic1: 'ICP-MS 분석',
      topic2: 'GC-MS 분석',
      topic3: 'HPLC 분석',
      topic4: '시료 전처리'
    },
    program4: {
      title: '물리 시험 평가 과정',
      duration: '3일 (24시간)',
      description: '물리적 시험 방법 및 평가 기술',
      topic1: '기계적 시험',
      topic2: '가연성 시험',
      topic3: '내구성 시험',
      topic4: '환경 시험'
    },
    program5: {
      title: 'ISO 17025 심사원 과정',
      duration: '5일 (40시간)',
      description: '시험소 인정 제도 및 심사 기법',
      topic1: 'ISO 17025 요구사항',
      topic2: '내부 심사 기법',
      topic3: '시정조치',
      topic4: '문서 관리'
    },
    program6: {
      title: '시험 보고서 작성 과정',
      duration: '2일 (16시간)',
      description: '전문적인 시험 보고서 작성 방법',
      topic1: '보고서 구조',
      topic2: '데이터 분석',
      topic3: '결과 해석',
      topic4: '불확도 평가'
    },
    benefit1: {
      title: '수료증 발급',
      desc: '공인된 교육 수료증 제공'
    },
    benefit2: {
      title: '전문가 강의',
      desc: '현장 경험이 풍부한 전문가 강의'
    },
    benefit3: {
      title: '교육 자료',
      desc: '실무에 활용 가능한 교육 자료 제공'
    },
    benefit4: {
      title: '사후 지원',
      desc: '교육 후 지속적인 기술 지원'
    }
  },

  // Regulation Research Page
  regulationResearch: {
    badge: '고객지원',
    title: '법령연구/규격개발',
    subtitle: '국내외 법령 연구 및 산업 표준 개발을 통한 기업 경쟁력 강화 지원',
    servicesTitle: '주요 서비스',
    servicesSubtitle: '법령 연구 및 규격 개발 전문 서비스',
    areasTitle: '연구 분야',
    areasSubtitle: '다양한 산업 분야의 법령 및 규격 연구',
    benefitsTitle: '기대 효과',
    benefitsSubtitle: '법령 연구 및 규격 개발을 통한 기업 가치 향상',
    ctaTitle: '법령 연구 및 규격 개발 문의',
    ctaDesc: '전문가 팀이 귀사의 규제 대응 및 표준화 전략을 지원합니다',
    ctaButton: '상담 문의하기',
    service1: {
      title: '법령 연구 및 분석',
      description: '국내외 제품 안전 관련 법령의 체계적 연구 및 분석',
      item1: '국내 법령 모니터링 및 분석',
      item2: '해외 규제 동향 조사',
      item3: '법령 개정 영향 평가',
      item4: '규제 대응 전략 수립',
      item5: '법령 해석 및 자문'
    },
    service2: {
      title: '산업 표준 개발',
      description: '산업 발전을 위한 표준 및 규격 개발',
      item1: 'KS 표준 개발 지원',
      item2: '단체 표준 제정',
      item3: '시험 방법 표준화',
      item4: '품질 기준 설정',
      item5: '표준 보급 및 교육'
    },
    service3: {
      title: '국제 규격 대응',
      description: '국제 표준 및 규격에 대한 전문적 대응',
      item1: 'ISO/IEC 표준 연구',
      item2: 'ASTM 규격 분석',
      item3: 'EN 규격 대응',
      item4: '국제 표준화 활동 참여',
      item5: '해외 인증 지원'
    },
    service4: {
      title: '규제 적합성 평가',
      description: '제품의 법령 및 규격 적합성 종합 평가',
      item1: '법령 적합성 검토',
      item2: '규격 준수 여부 평가',
      item3: '개선 방안 제시',
      item4: '인증 획득 지원',
      item5: '사후 관리 컨설팅'
    },
    area1: {
      title: '어린이/유아용품',
      desc: '완구 및 어린이제품 안전 규제'
    },
    area2: {
      title: '주얼리',
      desc: '귀금속 및 보석류 품질 기준'
    },
    area3: {
      title: '섬유/의류',
      desc: '섬유제품 안전 및 품질 규격'
    },
    area4: {
      title: '화장품',
      desc: '화장품 안전 기준 및 표시 규정'
    },
    area5: {
      title: '식품',
      desc: '식품 안전 관리 및 표시 기준'
    },
    area6: {
      title: '전자/전기',
      desc: '전기용품 안전 관리 규정'
    },
    benefit1: {
      title: '규제 리스크 최소화',
      desc: '법령 위반으로 인한 리스크 사전 예방'
    },
    benefit2: {
      title: '시장 진입 가속화',
      desc: '신속한 인증 획득으로 시장 진입 단축'
    },
    benefit3: {
      title: '경쟁력 강화',
      desc: '표준 선도를 통한 시장 경쟁력 확보'
    },
    benefit4: {
      title: '해외 진출 지원',
      desc: '국제 규격 대응으로 수출 확대'
    }
  },

  // Test Guides Page
  testGuides: {
    badge: '시험 안내서',
    title: '시험 안내서',
    subtitle: '각종 시험 항목별 상세 안내서와 절차 가이드를 제공합니다. 필요하신 자료를 다운로드하여 이용해 주세요.',
    backToHome: '홈으로',
    companyName: '청도 검사 기술 서비스 유한회사',
    ctaTitle: '추가 문의가 필요하신가요?',
    ctaDesc: '자료에 대한 문의사항이나 추가 정보가 필요하시면 언제든지 연락 주세요.',
    ctaButton: '문의하기',
    guides: {
      chemical: {
        title: '화학 시험 안내서',
        description: '화학 분석 시험의 전반적인 절차와 방법을 안내합니다.',
        files: [
          { name: '중금속 분석 가이드.pdf', size: '2.5 MB', date: '2024-01-15' },
          { name: '유해물질 검사 매뉴얼.pdf', size: '3.2 MB', date: '2024-01-10' },
          { name: '화학 성분 분석 절차.pdf', size: '1.8 MB', date: '2024-01-05' }
        ]
      },
      physical: {
        title: '물리 시험 안내서',
        description: '물리적 특성 시험의 방법과 기준을 설명합니다.',
        files: [
          { name: '강도 시험 가이드.pdf', size: '2.1 MB', date: '2024-01-20' },
          { name: '내구성 테스트 매뉴얼.pdf', size: '2.8 MB', date: '2024-01-18' },
          { name: '물리적 특성 분석.pdf', size: '1.5 MB', date: '2024-01-12' }
        ]
      },
      quality: {
        title: '품질 검사 안내서',
        description: '제품 품질 검사의 기준과 절차를 안내합니다.',
        files: [
          { name: '품질 관리 가이드.pdf', size: '3.5 MB', date: '2024-01-25' },
          { name: '검사 기준서.pdf', size: '2.2 MB', date: '2024-01-22' },
          { name: '불량 판정 매뉴얼.pdf', size: '1.9 MB', date: '2024-01-15' }
        ]
      },
      environmental: {
        title: '환경 시험 안내서',
        description: '환경 조건 시험의 방법과 기준을 제공합니다.',
        files: [
          { name: '온습도 시험 가이드.pdf', size: '2.4 MB', date: '2024-01-28' },
          { name: '환경 내구성 테스트.pdf', size: '3.1 MB', date: '2024-01-24' },
          { name: '기후 시험 절차.pdf', size: '2.0 MB', date: '2024-01-20' }
        ]
      },
      electrical: {
        title: '전기 안전 시험 안내서',
        description: '전기 안전 관련 시험의 절차와 기준을 설명합니다.',
        files: [
          { name: '전기 안전 가이드.pdf', size: '2.7 MB', date: '2024-02-01' },
          { name: '절연 시험 매뉴얼.pdf', size: '2.3 MB', date: '2024-01-30' },
          { name: '전압 테스트 절차.pdf', size: '1.7 MB', date: '2024-01-28' }
        ]
      },
      sample: {
        title: '시료 준비 안내서',
        description: '시험 시료의 준비와 보관 방법을 안내합니다.',
        files: [
          { name: '시료 채취 가이드.pdf', size: '2.0 MB', date: '2024-02-03' },
          { name: '시료 보관 매뉴얼.pdf', size: '1.6 MB', date: '2024-02-01' },
          { name: '전처리 절차서.pdf', size: '2.2 MB', date: '2024-01-29' }
        ]
      }
    }
  },

  // Certificates Page
  certificates: {
    badge: '인증서 샘플',
    title: '인증서 샘플',
    subtitle: '시험 성적서 및 각종 인증서 샘플을 확인하실 수 있습니다. 이미지를 클릭하면 확대하여 보실 수 있습니다.',
    backToHome: '홈으로',
    companyName: '청도 검사 기술 서비스 유한회사',
    download: '다운로드',
    issueDate: '발급일',
    validUntil: '유효기간',
    ctaTitle: '인증서 발급 문의',
    ctaDesc: '시험 성적서 발급이나 인증서 관련 문의사항이 있으시면 언제든지 연락 주세요.',
    ctaButton: '문의하기',
    certs: {
      iso17025: {
        title: 'ISO/IEC 17025 인증서',
        description: '국제 공인 시험기관 인증서'
      },
      ilac: {
        title: 'ILAC MRA 인정서',
        description: 'ILAC 상호인정협정 인정서'
      },
      testReport: {
        title: '시험 성적서 샘플',
        description: '화학 분석 시험 성적서 예시'
      },
      qms: {
        title: '품질 관리 인증서',
        description: 'ISO 9001 품질경영시스템 인증'
      },
      ems: {
        title: '환경 관리 인증서',
        description: 'ISO 14001 환경경영시스템 인증'
      },
      ohsms: {
        title: '안전 보건 인증서',
        description: 'ISO 45001 안전보건경영시스템 인증'
      }
    }
  },

  // Hazardous Limits Page
  hazardousLimits: {
    badge: '유해물질 규제 기준',
    title: '각국 유해물질 허용기준',
    subtitle: '미국, 유럽, 독일, 중국의 주요 유해물질 규제 기준과 허용 한도를 확인하세요. 각 국가별 규제 기관과 공식 출처 정보를 제공합니다.',
    backToHome: '홈으로',
    companyName: '청도 검사 기술 서비스 유한회사',
    countries: {
      usa: '미국',
      eu: '유럽',
      germany: '독일',
      china: '중국'
    },
    agenciesTitle: '주요 규제 기관',
    standardsTitle: '기준',
    substance: '물질명',
    limit: '허용 기준',
    application: '적용 대상',
    source: '출처/규정',
    referencesTitle: '공식 출처 및 참고 자료',
    noticeTitle: '중요 안내사항',
    noticeItems: [
      '본 자료는 참고용이며, 실제 시험 및 인증 시에는 최신 규정을 확인하시기 바랍니다.',
      '규제 기준은 수시로 업데이트되므로 공식 출처를 통해 최신 정보를 확인하세요.',
      '제품별로 적용되는 규정이 다를 수 있으니 전문가와 상담하시기 바랍니다.',
      '시험 의뢰 전 해당 국가의 최신 규제 요구사항을 확인하시기 바랍니다.'
    ],
    ctaTitle: '유해물질 시험이 필요하신가요?',
    ctaDesc: '각국 규제 기준에 맞는 정확한 시험 서비스를 제공합니다. 전문 상담원이 도와드리겠습니다.',
    ctaButton1: '시험 문의하기',
    ctaButton2: '전화 상담'
  },

  // International Standards Page
  internationalStandards: {
    badge: 'International Standards',
    title: '국제 규격 및 인증',
    subtitle: 'ISO, IEC, ILAC MRA, OECD GLP 등 국제적으로 인정받은 표준 규격에 따라 시험 분석 서비스를 제공합니다',
    backToHome: '홈으로',
    companyName: '청도 검사 기술 서비스 유한회사',
    isoTitle: 'ISO/IEC 17025',
    isoDesc: '국제표준화기구(ISO)와 국제전기기술위원회(IEC)가 공동으로 제정한 시험 및 교정 기관의 자격에 관한 국제 표준입니다.',
    isoPoints: [
      '시험소의 기술적 능력 입증',
      '품질 관리 시스템 운영',
      '정확하고 신뢰할 수 있는 결과 제공',
      '국제적으로 인정받는 시험 성적서 발행'
    ],
    isoRequirements: {
      title: 'ISO 17025 주요 요구사항',
      management: {
        title: '관리 요구사항',
        items: ['조직 구조', '문서 관리', '내부 심사', '시정 조치']
      },
      technical: {
        title: '기술 요구사항',
        items: ['인력 자격', '시설 환경', '시험 방법', '장비 관리']
      },
      quality: {
        title: '품질 보증',
        items: ['결과 품질', '데이터 무결성', '보고서 발행', '고객 만족']
      }
    },
    iecTitle: 'IEC 국제 전기 표준',
    iecDesc: '국제전기기술위원회(IEC)가 제정한 전기·전자 제품의 안전성 및 성능에 관한 국제 표준을 준수합니다.',
    iecStandards: [
      { code: 'IEC 60068', name: '환경 시험' },
      { code: 'IEC 62368', name: '전기 안전' },
      { code: 'IEC 61000', name: 'EMC 시험' },
      { code: 'IEC 62133', name: '배터리 안전' }
    ],
    ilacTitle: 'ILAC 상호인정협정',
    ilacDesc: '국제실험실인정협력체(ILAC)의 상호인정협정(MRA)을 통해 전 세계 100개 이상 국가에서 시험 결과를 인정받습니다.',
    ilacBenefits: [
      { title: '국제적 인정', description: '100개 이상 국가에서 시험 결과 인정' },
      { title: '신뢰성 보증', description: '국제 표준에 따른 품질 보증' },
      { title: '중복 시험 방지', description: '한 번의 시험으로 전 세계 통용' }
    ],
    ilacCountries: 'ILAC MRA 가입국',
    ilacCountriesDesc: '아시아, 유럽, 북미, 남미, 아프리카, 오세아니아 등 전 세계 주요 국가들이 ILAC MRA에 가입하여 시험 결과를 상호 인정하고 있습니다.',
    oecdTitle: 'OECD 우수실험실 운영기준',
    oecdDesc: '경제협력개발기구(OECD)의 Good Laboratory Practice 기준에 따라 화학물질 안전성 시험을 수행합니다.',
    oecdItems: [
      { title: '조직 및 인력', description: '적격한 인력과 명확한 책임 체계' },
      { title: '품질 보증 프로그램', description: '독립적인 품질 보증 시스템 운영' },
      { title: '시설 및 장비', description: '적절한 시설과 검증된 장비 사용' },
      { title: '시험 절차', description: '표준작업지침서(SOP)에 따른 시험 수행' }
    ],
    benefitsTitle: '국제 규격 준수의 이점',
    benefitsDesc: '국제적으로 인정받은 표준에 따른 시험으로 다양한 혜택을 누리실 수 있습니다',
    benefits: [
      { title: '수출입 간소화', description: '국제적으로 인정받는 시험 성적서로 통관 절차 간소화' },
      { title: '신뢰성 향상', description: '국제 표준 준수로 제품 신뢰성 및 브랜드 가치 향상' },
      { title: '비용 절감', description: '중복 시험 방지로 시간과 비용 절감' },
      { title: '시장 접근성', description: '전 세계 시장 진출을 위한 필수 요건 충족' },
      { title: '법적 보호', description: '국제 규정 준수로 법적 리스크 최소화' },
      { title: '고객 만족', description: '신뢰할 수 있는 시험 결과로 고객 만족도 향상' }
    ],
    ctaTitle: '국제 규격 시험이 필요하신가요?',
    ctaDesc: 'ISO 17025 인증 시험소에서 국제적으로 인정받는 시험 서비스를 제공합니다',
    ctaButton1: '문의하기',
    ctaButton2: '홈으로 돌아가기',
    countries: ['한국', '미국', '일본', '중국', '독일', '영국', '프랑스', '캐나다', '호주', '싱가포르']
  },

  // Inquiry Page
  inquiry: {
    badge: '고객지원',
    title: '문의하기',
    subtitle: '시험 관련 문의사항이나 궁금한 점을 남겨주시면 빠르게 답변드리겠습니다.',
    backToHome: '홈으로',
    companyName: 'ISO 17025 Testing Laboratory',
    companySubtitle: 'ILAC Accredited Testing Services',
    tabs: {
      form: '문의 작성',
      list: '문의 내역'
    },
    formTitle: '문의 작성',
    formSubtitle: '궁금하신 사항을 자세히 작성해주세요',
    successTitle: '문의가 성공적으로 접수되었습니다!',
    successDesc: '빠른 시일 내에 답변드리겠습니다.',
    fields: {
      name: '이름',
      nameRequired: '이름 *',
      company: '회사명',
      email: '이메일',
      emailRequired: '이메일 *',
      phone: '연락처',
      phoneRequired: '연락처 *',
      inquiryType: '문의 유형',
      inquiryTypeRequired: '문의 유형 *',
      inquiryTypePlaceholder: '문의 유형을 선택해주세요',
      message: '문의 내용',
      messageRequired: '문의 내용 *',
      messagePlaceholder: '문의 내용을 자세히 작성해주세요 (최대 500자)',
      submit: '문의 접수하기'
    },
    inquiryTypes: {
      test: '시험 문의',
      certificate: '인증서 문의',
      cost: '비용 문의',
      schedule: '일정 문의',
      technical: '기술 문의',
      other: '기타 문의'
    },
    privacyTitle: '개인정보 수집 및 이용 안내',
    privacyDesc: '문의 처리를 위해 이름, 이메일, 연락처 정보가 수집되며, 답변 완료 후 3개월간 보관됩니다.',
    listTitle: '문의 내역',
    listSubtitle: '접수된 문의 내역을 확인하실 수 있습니다',
    loading: '문의 내역을 불러오는 중...',
    emptyTitle: '문의 내역이 없습니다',
    emptyDesc: '첫 문의를 작성해보세요!',
    emptyButton: '문의 작성하기',
    status: {
      answered: '답변 완료',
      pending: '답변 대기'
    },
    viewDetails: '클릭하여 상세 내용 보기',
    collapse: '접기',
    inquiryContent: '문의 내용',
    answerPending: '답변 대기 중입니다',
    answerPendingDesc: '빠른 시일 내에 답변드리겠습니다.',
    ctaTitle: '긴급 문의가 필요하신가요?',
    ctaDesc: '긴급한 사항은 전화로 문의해주시면 즉시 상담해드립니다.',
    ctaPhone: '고객 상담 전화',
    ctaPhoneNumber: '0532-55566163/55566165',
    footerEmail: '이메일',
    footerEmailValue: 'ctl@centrallab.biz'
  },

  // NotFound Page
  notFound: {
    title: 'This page has not been generated',
    subtitle: 'Tell me more about this page, so I can generate it'
  },

  // Product Testing Page
  productTesting: {
    badge: '주요 사업',
    title: '제품 적합성 평가',
    subtitle: '다양한 제품군에 대한 전문적인 시험 평가 서비스를 제공합니다. 국제 규격에 따른 정확하고 신뢰할 수 있는 시험 결과를 보장합니다.',
    backToHome: '홈으로',
    companyName: '청도 검사 기술 서비스 유한회사',
    categoriesTitle: '제품 카테고리',
    categoriesSubtitle: '각 제품군별 특화된 시험 서비스를 제공합니다',
    whyTitle: '왜 저희를 선택해야 할까요?',
    whySubtitle: '전문성과 신뢰성을 바탕으로 최고의 시험 서비스를 제공합니다',
    processTitle: '시험 진행 프로세스',
    processSubtitle: '체계적인 프로세스로 정확한 시험 결과를 제공합니다',
    ctaTitle: '시험 문의가 필요하신가요?',
    ctaDesc: '전문 상담원이 제품에 맞는 최적의 시험 방법을 안내해드립니다.',
    ctaButton1: '온라인 문의',
    ctaButton2: '전화 문의',
    ctaPhone: '전화 문의',
    ctaPhoneNumber: '0532-55566163/55566165',
    viewTests: '시험 항목 보기',
    applicableStandards: '적용 규격',
    features: [
      { title: 'ISO/IEC 17025 인증', description: '국제적으로 인정받는 공인 시험소', icon: 'ri-award-line' },
      { title: '최신 시험 장비', description: '첨단 분석 장비를 통한 정밀 시험', icon: 'ri-microscope-line' },
      { title: '전문 인력', description: '풍부한 경험의 전문 시험 인력', icon: 'ri-team-line' },
      { title: '신속한 처리', description: '빠른 시험 진행 및 결과 제공', icon: 'ri-time-line' }
    ],
    processSteps: [
      { step: '01', title: '문의 접수', description: '제품 정보 및 시험 요구사항 확인', icon: 'ri-customer-service-line' },
      { step: '02', title: '견적 제공', description: '시험 항목별 상세 견적 안내', icon: 'ri-file-list-line' },
      { step: '03', title: '시료 접수', description: '시료 수령 및 시험 준비', icon: 'ri-inbox-line' },
      { step: '04', title: '시험 진행', description: '전문 장비를 활용한 정밀 시험', icon: 'ri-flask-line' },
      { step: '05', title: '결과 발행', description: '시험 성적서 발행 및 전달', icon: 'ri-file-text-line' }
    ],
    categories: [
      {
        id: 'jewelry',
        name: '주얼리',
        description: '귀금속 및 보석류의 품질과 안전성을 검증합니다',
        tests: [
          { category: '성분 분석', items: ['귀금속 순도 분석', '합금 성분 분석', '도금층 두께 측정', '보석 감정'] },
          { category: '유해물질 검사', items: ['납(Pb)', '카드뮴(Cd)', '니켈 용출', '6가 크롬'] },
          { category: '물리적 시험', items: ['내마모성', '내부식성', '도금 밀착력', '인장강도'] }
        ],
        standards: ['US CPSC/CPSIA', 'US State Law', 'EU REACH', 'GB', 'KC', 'SAH 인증규격', '925 Silver', '귀금속 Labeling 규정']
      },
      {
        id: 'children',
        name: '어린이용품',
        description: '어린이 제품의 안전성과 품질을 철저히 검사합니다',
        tests: [
          { category: '물리적 안전성', items: ['작은 부품', '날카로운 끝', '낙하 시험', '압축 시험', '인장 시험', '비틀림 시험'] },
          { category: '화학적 안전성', items: ['중금속 8종', '프탈레이트 6종', '아조 염료', 'BPA', '포름알데히드'] },
          { category: '가연성 시험', items: ['섬유 가연성', '플라스틱 가연성'] }
        ],
        standards: ['ASTM F963', 'EN 71', 'GB 6675', 'CPSIA', 'ISO 8124']
      },
      {
        id: 'baby',
        name: '유아용품',
        description: '영유아 제품의 안전성을 최우선으로 검증합니다',
        tests: [
          { category: '물리적 안전성', items: ['질식 위험', '날카로운 부분', '끼임 위험', '안정성 시험'] },
          { category: '화학적 안전성', items: ['중금속', '프탈레이트', 'BPA', '포름알데히드', 'VOCs'] },
          { category: '미생물 시험', items: ['총 호기성 생균수', '대장균군', '황색포도상구균', '녹농균'] }
        ],
        standards: ['ASTM F2194', 'EN 14372', 'GB 28482', 'CPSIA', 'FDA']
      },
      {
        id: 'stationery',
        name: '문구용품',
        description: '학생용 문구류의 안전성과 품질을 평가합니다',
        tests: [
          { category: '화학적 안전성', items: ['중금속 8종', '방향족 아민', '프탈레이트', '포름알데히드'] },
          { category: '물리적 안전성', items: ['날카로운 끝', '캡 안전성', '펜 끝 안전성'] },
          { category: '성능 시험', items: ['필기 성능', '지우개 성능', '접착력', '내수성'] }
        ],
        standards: ['EN 71-3', 'ASTM D4236', 'GB 21027', 'ISO 11540']
      },
      {
        id: 'hygiene',
        name: '위생용품',
        description: '위생용품의 안전성과 효능을 검증합니다',
        tests: [
          { category: '미생물 시험', items: ['총 호기성 생균수', '대장균', '녹농균', '황색포도상구균', '곰팡이'] },
          { category: '화학적 안전성', items: ['중금속', '메탄올', '포름알데히드', '방부제', 'pH'] },
          { category: '효능 시험', items: ['항균 효과', '살균 효과', '세정력'] }
        ],
        standards: ['GB 15979', 'ISO 22196', 'ASTM E2149', 'FDA']
      },
      {
        id: 'safety',
        name: '안전 용품',
        description: '개인 보호 장비의 안전성과 성능을 평가합니다',
        tests: [
          { category: '물리적 성능', items: ['충격 흡수', '관통 저항', '인장강도', '내마모성'] },
          { category: '화학적 안전성', items: ['유해물질', 'pH', '피부 자극성'] },
          { category: '기능성 시험', items: ['방수성', '통기성', '난연성', '내열성'] }
        ],
        standards: ['EN 420', 'ANSI Z87.1', 'EN 388', 'ISO 20345', 'GB 2626']
      },
      {
        id: 'textile',
        name: '섬유용품',
        description: '섬유 제품의 품질과 안전성을 종합적으로 평가합니다',
        tests: [
          { category: '화학적 안전성', items: ['아조 염료', '포름알데히드', 'pH', '중금속', '알레르기 염료', 'DMFu'] },
          { category: '물리적 성능', items: ['인장강도', '인열강도', '마모 저항성', '필링 시험', '치수 변화율'] },
          { category: '기능성 시험', items: ['세탁 견뢰도', '땀 견뢰도', '마찰 견뢰도', '일광 견뢰도', '방수성', '통기성'] },
          { category: '가연성 시험', items: ['섬유 가연성', '난연성 평가'] }
        ],
        standards: ['OEKO-TEX Standard 100', 'GB 18401', 'REACH', 'CPSIA', 'EN 14682', 'ASTM D4966', 'ISO 105']
      },
      {
        id: 'electrical',
        name: '가정용 전기제품',
        description: '가전제품의 전기 안전성과 성능을 검증합니다',
        tests: [
          { category: '전기 안전성', items: ['절연 저항', '내전압', '접지 연속성', '누설 전류', '온도 상승'] },
          { category: '기계적 안전성', items: ['구조 검사', '기계적 강도', '안정성 시험', '낙하 시험'] },
          { category: '화학적 안전성', items: ['유해물질(RoHS)', '난연성', 'PAHs', '프탈레이트'] },
          { category: 'EMC 시험', items: ['전자파 적합성', '전자파 방출', '전자파 내성'] }
        ],
        standards: ['IEC 60335', 'GB 4706', 'UL 1026', 'EN 60335', 'KC 인증', 'CE 인증', 'RoHS', 'REACH']
      },
      {
        id: 'game',
        name: '게임',
        description: '게임 제품의 안전성과 품질을 평가합니다',
        tests: [
          { category: '물리적 안전성', items: ['작은 부품', '날카로운 끝', '낙하 시험', '압축 시험'] },
          { category: '화학적 안전성', items: ['중금속', '프탈레이트', 'PAHs', '아조 염료'] }
        ],
        standards: ['ASTM F963', 'EN 71', 'GB 6675', 'CPSIA']
      },
      {
        id: 'silver',
        name: 'Silver 용품',
        description: 'Silver 제품의 순도와 품질을 검증합니다',
        tests: [
          { category: '성분 분석', items: ['Silver 순도 분석', '합금 성분 분석', '도금층 분석'] },
          { category: '유해물질 검사', items: ['납(Pb)', '카드뮴(Cd)', '니켈 용출', '중금속'] },
          { category: '물리적 시험', items: ['내마모성', '내부식성', '도금 밀착력'] }
        ],
        standards: ['925 Silver', 'US CPSC', 'EU REACH', 'GB', 'KC']
      },
      {
        id: 'furniture',
        name: '실내 가구 제품',
        description: '실내 가구의 안전성과 내구성을 평가합니다',
        tests: [
          { category: '물리적 안전성', items: ['안정성 시험', '내구성 시험', '낙하 시험', '하중 시험'] },
          { category: '화학적 안전성', items: ['포름알데히드', 'VOCs', '중금속', '난연성'] },
          { category: '재료 시험', items: ['목재 강도', '접착제 성능', '표면 마감', '내마모성'] }
        ],
        standards: ['EN 12520', 'BIFMA', 'GB 28007', 'CARB', 'REACH']
      },
      {
        id: 'packaging',
        name: '포장물(내·외 포장)',
        description: '포장재의 안전성과 성능을 검증합니다',
        tests: [
          { category: '물리적 시험', items: ['압축 강도', '낙하 시험', '진동 시험', '충격 시험'] },
          { category: '화학적 안전성', items: ['중금속', '프탈레이트', 'PAHs', '식품 접촉 물질'] },
          { category: '성능 시험', items: ['방수성', '내열성', '밀봉 성능', '인쇄 품질'] }
        ],
        standards: ['ISTA', 'ASTM D4169', 'ISO 12048', 'GB/T 4857', 'FDA', 'EU 10/2011']
      }
    ]
  },

  // Certification Page
  certification: {
    badge: '주요 사업',
    title: '인증업무/인증 마크',
    subtitle: '글로벌 시장 진출을 위한 각국의 필수 인증 및 인증 마크 취득을 지원합니다. CCC, CE, FCC, UL 등 다양한 국제 인증 서비스를 제공합니다.',
    backToHome: '홈으로',
    companyName: '청도 검사 기술 서비스 유한회사',
    servicesTitle: '주요 인증 서비스',
    servicesSubtitle: '각국의 규제 요구사항에 맞는 인증 서비스를 제공합니다',
    benefitsTitle: '인증의 이점',
    benefitsSubtitle: '국제 인증을 통해 얻을 수 있는 다양한 혜택',
    processTitle: '인증 진행 프로세스',
    processSubtitle: '체계적인 인증 절차로 빠르고 정확한 인증 취득을 지원합니다',
    ctaTitle: '인증 문의가 필요하신가요?',
    ctaDesc: '전문 상담원이 제품에 맞는 최적의 인증 방법을 안내해드립니다.',
    ctaButton1: '온라인 문의',
    ctaButton2: '전화 문의',
    ctaPhone: '전화 문의',
    ctaPhoneNumber: '0532-55566163/55566165',
    viewDetails: '상세 보기',
    processingPeriod: '처리 기간',
    validityPeriod: '유효 기간',
    applicableProducts: '적용 제품',
    certificationProcess: '인증 절차',
    benefits: [
      {
        title: '글로벌 시장 진출',
        description: '각국의 인증을 통해 전 세계 시장에 제품을 수출할 수 있습니다',
        icon: 'ri-global-line'
      },
      {
        title: '제품 신뢰도 향상',
        description: '국제 인증 마크는 제품의 품질과 안전성을 보증합니다',
        icon: 'ri-shield-check-line'
      },
      {
        title: '경쟁력 강화',
        description: '인증을 통해 시장에서의 경쟁 우위를 확보할 수 있습니다',
        icon: 'ri-line-chart-line'
      },
      {
        title: '전문 컨설팅',
        description: '인증 전 과정에 대한 전문적인 컨설팅을 제공합니다',
        icon: 'ri-customer-service-line'
      }
    ],
    processSteps: [
      { step: '01', title: '상담 및 견적', description: '제품 및 인증 요구사항 확인', icon: 'ri-customer-service-line' },
      { step: '02', title: '계약 및 신청', description: '인증 계약 체결 및 신청서 제출', icon: 'ri-file-text-line' },
      { step: '03', title: '시험 진행', description: '제품 샘플 시험 및 평가', icon: 'ri-flask-line' },
      { step: '04', title: '공장 심사', description: '생산 공장 현장 심사 (필요시)', icon: 'ri-building-line' },
      { step: '05', title: '인증서 발급', description: '인증서 및 마크 사용 승인', icon: 'ri-award-line' }
    ],
    certifications: [
      {
        id: 'ccc',
        name: 'CCC 인증',
        fullName: 'China Compulsory Certification',
        country: '중국',
        description: 'System 인증',
        products: ['전기전자제품', '자동차 부품', '안전유리', '소방제품', '무선통신기기', '정보기술기기'],
        process: ['신청서 제출 및 계약', '제품 샘플 시험', '공장 심사', '인증서 발급', '사후 관리'],
        period: '60-90일',
        validity: '5년'
      },
      {
        id: 'ce',
        name: 'CE 마크',
        fullName: 'Conformité Européenne',
        country: '유럽연합',
        description: 'SAH 안전 위생 마크',
        products: ['전기전자제품', '기계류', '의료기기', '완구', '개인보호장비', '건설자재'],
        process: ['적용 지침 확인', '적합성 평가', '기술문서 작성', 'CE 마크 부착', '적합성 선언서 작성'],
        period: '30-60일',
        validity: '제품 변경시까지'
      },
      {
        id: 'fcc',
        name: 'FCC 인증',
        fullName: 'Federal Communications Commission',
        country: '미국',
        description: '품질 보증 마크',
        products: ['무선통신기기', '컴퓨터 및 주변기기', '가전제품', 'LED 조명', '산업용 전자기기'],
        process: ['제품 분류 확인', 'EMC 시험', '인증서 신청', 'FCC ID 발급', '라벨 부착'],
        period: '20-40일',
        validity: '영구'
      },
      {
        id: 'system',
        name: 'System 인증',
        fullName: 'Management System Certification',
        country: '국제',
        description: 'HSPM, 자동차, 사회적 책임 SA8000, ISO 9000/ISO 14000',
        products: ['HSPM (위해요소중점관리)', '자동차 산업', 'SA8000 (사회적 책임)', 'ISO 9000 (품질경영)', 'ISO 14000 (환경경영)', '통합경영시스템'],
        process: ['경영시스템 구축', '문서화 작업', '내부 심사', '인증 심사', '인증서 발급'],
        period: '90-120일',
        validity: '3년 (연간 사후심사)'
      },
      {
        id: 'sah',
        name: 'SAH 안전 위생 마크',
        fullName: 'Safety And Hygiene Mark',
        country: '국제',
        description: '주얼리/귀금속/보석류, 유용품, Silver용품, 위생 용품, 개인 안전 보호 장구',
        products: ['주얼리/귀금속/보석류', '유용품', 'Silver 용품', '위생 용품', '개인 안전 보호 장구', '생활용품'],
        process: ['제품 안전성 평가', '위생 시험', '유해물질 검사', '품질 검증', '인증서 발급'],
        period: '30-60일',
        validity: '2년'
      },
      {
        id: 'quality',
        name: '품질 보증 마크',
        fullName: 'Quality Assurance Mark',
        country: '국제',
        description: '귀금속/보석류 품질 보증',
        products: ['귀금속 제품', '보석류', '다이아몬드', '금/은 제품', '진주', '고급 주얼리'],
        process: ['성분 분석', '품질 검사', '순도 측정', '감정서 발급', '품질 보증서 발급'],
        period: '15-30일',
        validity: '영구'
      },
      {
        id: 'ul',
        name: 'UL 인증',
        fullName: 'Underwriters Laboratories',
        country: '미국',
        description: '미국의 제품 안전 인증 기관으로, 전 세계적으로 인정받는 안전 마크입니다.',
        products: ['전기전자제품', '화재 안전 제품', '산업용 장비', '의료기기', '건축자재', '가전제품'],
        process: ['제품 평가 신청', '샘플 시험', '공장 심사', 'UL 마크 승인', '정기 공장 심사'],
        period: '60-90일',
        validity: '연간 갱신'
      },
      {
        id: 'rohs',
        name: 'RoHS 인증',
        fullName: 'Restriction of Hazardous Substances',
        country: '유럽연합',
        description: '전기전자제품의 유해물질 사용 제한 지침입니다.',
        products: ['전기전자제품', '가전제품', '조명기기', '완구', '의료기기', '모니터링 장비'],
        process: ['제품 분석', '유해물질 시험', '적합성 평가', '인증서 발급', '기술문서 작성'],
        period: '15-30일',
        validity: '제품 변경시까지'
      },
      {
        id: 'reach',
        name: 'REACH 인증',
        fullName: 'Registration, Evaluation, Authorization of Chemicals',
        country: '유럽연합',
        description: 'EU의 화학물질 등록, 평가, 허가 및 제한에 관한 규정입니다.',
        products: ['화학물질', '섬유제품', '전기전자제품', '완구', '가구', '포장재'],
        process: ['SVHC 확인', '화학물질 분석', '적합성 평가', '보고서 작성', '인증서 발급'],
        period: '20-40일',
        validity: '1년'
      },
      {
        id: 'cpsia',
        name: 'CPSIA 인증',
        fullName: 'Consumer Product Safety Improvement Act',
        country: '미국',
        description: '미국 소비자제품안전개선법으로, 어린이 제품의 안전 기준입니다.',
        products: ['어린이 완구', '유아용품', '어린이 의류', '학용품', '어린이 가구', '어린이 액세서리'],
        process: ['제품 시험', '납 함량 검사', '프탈레이트 검사', 'CPC 인증서 작성', '라벨 부착'],
        period: '15-30일',
        validity: '제품 변경시까지'
      },
      {
        id: 'astm',
        name: 'ASTM F963',
        fullName: 'American Society for Testing and Materials',
        country: '미국',
        description: '미국 완구 안전 표준으로, 완구의 물리적, 화학적 안전성을 평가합니다.',
        products: ['완구', '게임', '퍼즐', '인형', '스포츠 완구', '교육용 완구'],
        process: ['물리적 시험', '화학적 시험', '가연성 시험', '적합성 평가', '인증서 발급'],
        period: '20-40일',
        validity: '제품 변경시까지'
      }
    ]
  },

  // Certification Support Page
  certificationSupport: {
    badge: '고객지원',
    title: '인증제도 지원(분야별)',
    subtitle: '각 분야별 국내외 인증 제도에 대한 전문적인 컨설팅과 시험 서비스를 제공합니다',
    backToHome: '홈으로',
    processTitle: '인증 지원 프로세스',
    processSubtitle: '체계적인 프로세스로 인증 취득을 지원합니다',
    ctaTitle: '인증 관련 문의가 있으신가요?',
    ctaDesc: '전문 컨설턴트가 귀사의 제품에 필요한 인증을 안내해 드립니다',
    ctaButton: '상담 문의하기',
    processSteps: [
      { step: '1', title: '상담 및 분석', desc: '제품 및 인증 요구사항 분석', icon: 'ri-discuss-line' },
      { step: '2', title: '시험 계획', desc: '필요한 시험 항목 및 일정 수립', icon: 'ri-file-list-line' },
      { step: '3', title: '시험 진행', desc: '국제 표준에 따른 정밀 시험', icon: 'ri-test-tube-line' },
      { step: '4', title: '보고서 발행', desc: '시험 결과 보고서 작성', icon: 'ri-file-text-line' },
      { step: '5', title: '인증 지원', desc: '인증 기관 제출 및 사후 관리', icon: 'ri-award-line' }
    ],
    certifications: {
      children: {
        title: '어린이/유아용품 인증',
        description: '어린이와 유아의 안전을 보장하는 국내외 인증 지원',
        standards: [
          { name: 'KC 인증', desc: '한국 어린이제품 안전 특별법 인증' },
          { name: 'EN 71', desc: '유럽 완구 안전 규격' },
          { name: 'ASTM F963', desc: '미국 완구 안전 규격' },
          { name: 'CPSIA', desc: '미국 소비자제품 안전 개선법' },
          { name: 'GB 6675', desc: '중국 완구 안전 기술 규범' }
        ]
      },
      jewelry: {
        title: '주얼리 인증',
        description: '귀금속 및 보석류의 품질과 안전성을 보증하는 인증',
        standards: [
          { name: 'KC 인증', desc: '한국 귀금속 및 보석류 품질 인증' },
          { name: 'REACH', desc: '유럽 화학물질 규제' },
          { name: 'RoHS', desc: '유해물질 사용 제한 지침' },
          { name: 'California Prop 65', desc: '캘리포니아 유해물질 경고 규정' },
          { name: 'Nickel Release', desc: '니켈 용출 시험' }
        ]
      },
      textile: {
        title: '섬유/의류 인증',
        description: '섬유 제품의 안전성과 품질을 인증하는 국제 표준',
        standards: [
          { name: 'Oeko-Tex Standard 100', desc: '유해물질 검사 인증' },
          { name: 'GOTS', desc: '유기농 섬유 국제 인증' },
          { name: 'REACH', desc: '유럽 화학물질 규제' },
          { name: 'KC 인증', desc: '한국 섬유제품 품질 인증' },
          { name: 'CPSIA', desc: '미국 소비자제품 안전법' }
        ]
      },
      cosmetics: {
        title: '화장품 인증',
        description: '화장품의 안전성과 효능을 검증하는 인증 제도',
        standards: [
          { name: 'ISO 22716', desc: '화장품 GMP 국제 표준' },
          { name: 'CPNP', desc: '유럽 화장품 신고 포털' },
          { name: 'FDA 등록', desc: '미국 식품의약국 등록' },
          { name: 'CFDA', desc: '중국 식품의약품 감독관리국 인증' },
          { name: 'KC 인증', desc: '한국 화장품 안전 기준' }
        ]
      },
      food: {
        title: '식품 인증',
        description: '식품의 안전성과 품질을 보장하는 인증 시스템',
        standards: [
          { name: 'HACCP', desc: '식품 안전 관리 인증' },
          { name: 'ISO 22000', desc: '식품 안전 경영 시스템' },
          { name: 'FSSC 22000', desc: '식품 안전 시스템 인증' },
          { name: 'Halal', desc: '할랄 인증' },
          { name: 'Kosher', desc: '코셔 인증' }
        ]
      },
      electronics: {
        title: '전자/전기 인증',
        description: '전자제품의 안전성과 성능을 검증하는 국제 인증',
        standards: [
          { name: 'CE 마크', desc: '유럽 제품 안전 인증' },
          { name: 'FCC', desc: '미국 연방통신위원회 인증' },
          { name: 'RoHS', desc: '유해물질 사용 제한 지침' },
          { name: 'REACH', desc: '유럽 화학물질 규제' },
          { name: 'KC 인증', desc: '한국 전자제품 안전 인증' }
        ]
      },
      medical: {
        title: '의료기기 인증',
        description: '의료기기의 안전성과 효능을 보증하는 인증',
        standards: [
          { name: 'ISO 13485', desc: '의료기기 품질경영시스템' },
          { name: 'CE 마크 (MDR)', desc: '유럽 의료기기 규정' },
          { name: 'FDA 510(k)', desc: '미국 의료기기 시판 전 신고' },
          { name: 'MFDS 인증', desc: '한국 식품의약품안전처 인증' },
          { name: 'CFDA', desc: '중국 의료기기 등록' }
        ]
      },
      environmental: {
        title: '환경 인증',
        description: '환경 친화적 제품을 인증하는 국제 표준',
        standards: [
          { name: 'ISO 14001', desc: '환경경영시스템 인증' },
          { name: 'Carbon Footprint', desc: '탄소발자국 인증' },
          { name: 'FSC', desc: '산림관리협의회 인증' },
          { name: 'Energy Star', desc: '에너지 효율 인증' },
          { name: '환경표지', desc: '한국 환경표지 인증' }
        ]
      }
    },
    standardsTitle: '주요 인증 표준'
  }
};